<template>
  <div class="d-flex justify-content-end mt-4">
    <base-button 
      @click="downloadCSVData" 
      stylevariant="hardlink"
      cus_style="height:100%; margin-top: 7px; font-size: 16px"
    >Export CSV</base-button>
    <!-- <div @click="downloadCSVData" class="p-2 hard-link" >Export CSV</div> -->
    <b-pagination
      v-model="currentPage"
      :total-rows="totalRows"
      :per-page="PAGE_SIZE"
      first-text="<<"
      prev-text="<"
      next-text=">"
      last-text=">>"
    >
    </b-pagination>
  </div>
</template>

<script>
import { PAGE_SIZE } from "@/constants";
import BaseButton from "./BaseButton.vue";

export default {
  emits: ["set-page"],
  components: {
    BaseButton,
  },
  props: {
    totalRows: {
      type: Number,
      required: true,
    },
    activePage: {
      type: Number,
      required: true,
    },
    tableName: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      PAGE_SIZE,
      currentPage: this.activePage,
    };
  },
  methods: {
    setPage(pageNo) {
      if (pageNo !== null) this.$emit("set-page", pageNo);
    },
    downloadCSVData() {
      var columns_headers = [];
      this.$parent.columns.forEach((column)=>{
        var accessor = column.sortValue.replace('Styled','').replace("Formatted","");
        columns_headers.push(accessor);
      });
      let csv = columns_headers + "\n";
      this.$parent.data.forEach((row) => {
        columns_headers.forEach((field) => {
          var row_value = null;
          if(field == "amount" || field == "amount_due")
            row_value = row["currency"] + " " + row[field];
          else
            row_value = row[field];
          csv += row_value + ", ";
        });
        csv += "\n";
      });
      const anchor = document.createElement('a');
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      anchor.target = '_blank';
      var today = new Date();
      var table_name = "";
      if (this.tableName)
        table_name = this.tableName;
      else
        table_name = this.$route.name;
      anchor.download = `${table_name}-${today.getFullYear()}-${today.getMonth()}-${today.getDay()}`;
      anchor.click();
    },
  },
  watch: {
    currentPage(page) {
      return this.setPage(page);
    },
  },
};
</script>

<style lang="scss">
@import './BasePagination.scss';
</style>
